export default [
  { type: 'text', label: 'Metin Alanı', model: 'textField' },
  { type: 'email', label: 'E-posta', model: 'emailField' },
  { type: 'select', label: 'Seçim Kutusu', model: 'selectField', options: ['A', 'B', 'C'] },
  { type: 'checkbox', label: 'Onay Kutusu', model: 'checkboxField' }
];